import classNames from 'classnames';

import { Profile } from '../../../Profile/Profile';
import { ExpandButton } from '../../../ExpandButton/ExpandButton';
import { useExpanded } from '../../../utils/useExpanded';
import { getImageSources } from '../../../../helpers/images';
import { ListHeader } from '../../../ListHeader/ListHeader';

import { useIsOverflown } from './useIsOverflown';

import type { VFC, MouseEventHandler } from 'react';

import * as styles from './EditorialHeading.module.scss';

export type EditorialHeadingProps = {
  imageUrl?: string;
  header?: string;
  content?: string;
  className?: string;
};

export const EditorialHeading: VFC<EditorialHeadingProps> = ({
  imageUrl,
  header,
  content,
  className,
}) => {
  const [isOverflown, ref] = useIsOverflown();
  const { isExpanded, onExpandButtonClick } = useExpanded(false);

  const onButtonClick: MouseEventHandler<HTMLElement> = (event) => {
    event.preventDefault();
    onExpandButtonClick();
  };

  const textClassName = classNames(styles.editorialText, {
    [styles.editorialTextExpanded]: isExpanded,
  });

  return (
    <div className={classNames(styles.editorialHeading, className)}>
      <Profile
        imageSources={getImageSources({
          imageUrl,
          imagePreset: 'editorialProfile',
          aspectRatio: 'square',
        })}
        className={styles.profile}
      />
      <div className={styles.editorialHeadingContent}>
        <ListHeader headerContent={header} className={styles.editorialHeader} />
        {/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
        <p ref={ref} className={textClassName} onClick={onButtonClick}>
          {/* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
          {content}
        </p>
        {isOverflown && !isExpanded && (
          <ExpandButton
            isExpanded={isExpanded}
            className={styles.expandButton}
            onClick={onButtonClick}
          />
        )}
      </div>
    </div>
  );
};
